// Auto-extracted from Landing.jsx — bilingual landing copy.

import {
  Bot, Boxes, Brain, Building2, Cpu, Database, FileText, Gauge, Globe,
  Lock, Radio, ShieldCheck, Users, Wallet, Workflow, Wrench,
} from 'lucide-react';

const T = {
  nav: {
    platform:     { en: 'Platform',     ar: 'المنصة' },
    intelligence: { en: 'Intelligence', ar: 'الذكاء' },
    modules:      { en: 'Modules',      ar: 'الوحدات' },
    security:     { en: 'Security',     ar: 'الأمان' },
    faq:          { en: 'FAQ',          ar: 'الأسئلة' },
    signIn:       { en: 'Sign in',          ar: 'تسجيل الدخول' },
    requestAccess:{ en: 'Request access',   ar: 'طلب الوصول' },
  },
  hero: {
    eyebrow: { en: 'REVA · Property operations platform', ar: 'REVA · منصّة إدارة العقارات' },
    title_a: { en: 'Run your property',                    ar: 'أدِر عقاراتك' },
    title_b: { en: 'operations',                           ar: 'بالكامل' },
    title_c: { en: 'in one place.',                        ar: 'من مكان واحد.' },
    sub: {
      en: 'Leasing, rent collection, maintenance, accounting, and reporting — built for operators in Saudi Arabia.',
      ar: 'التأجير، التحصيل، الصيانة، المحاسبة، والتقارير — مبنيّة لمشغّلي العقارات في المملكة العربية السعودية.',
    },
    ctaPrimary: { en: 'Request a demo',  ar: 'اطلب عرضًا توضيحيًا' },
    ctaGhost:   { en: 'Explore platform', ar: 'تصفّح المنصّة' },
    chips: [
      { k: { en: 'Active leases',     ar: 'العقود الفعّالة' },  v: '—', d: { en: '',  ar: '' } },
      { k: { en: 'Occupancy',         ar: 'نسبة الإشغال' },      v: '—', d: { en: '',  ar: '' } },
      { k: { en: 'Collections rate',  ar: 'نسبة التحصيل' },       v: '—', d: { en: '',  ar: '' } },
      { k: { en: 'NOI · annualized',  ar: 'صافي الدخل · سنوي' },  v: '—', d: { en: '',  ar: '' } },
    ],
  },
  // ── NEW · Operations modules grid (real estate first, AI embedded)
  modules: {
    eyebrow: { en: 'What REVA covers',                          ar: 'ماذا تغطّي REVA' },
    titleA:  { en: 'Everything you need to manage',             ar: 'كل ما تحتاجه لإدارة' },
    titleB:  { en: 'a real estate portfolio.',                  ar: 'محفظتك العقاريّة.' },
    sub: {
      en: 'Six modules covering the full lifecycle of a property — from move-in to renewal.',
      ar: 'ست وحدات تغطّي دورة حياة العقار كاملة — من بداية الإيجار حتى تجديده.',
    },
    items: [
      {
        icon: 'Building2',
        title: { en: 'Leasing & renewals',    ar: 'التأجير والتجديد' },
        desc:  { en: 'Applications, screening, contract generation, and structured renewal workflows.', ar: 'الطلبات، الفرز، إنشاء العقود، وسير عمل التجديد المنظّم.' },
        points: [
          { en: 'Lease abstraction from PDF',  ar: 'استخلاص بنود العقد من ملفات PDF' },
          { en: 'Renewal probability scoring', ar: 'تقييم احتماليّة تجديد العقد' },
        ],
        aiEmbedded: true,
        to: '/lease-abstract',
      },
      {
        icon: 'Wallet',
        title: { en: 'Rent collection',       ar: 'تحصيل الإيجار' },
        desc:  { en: 'Automated invoicing, payment links, late-fee logic, and tenant reminders.', ar: 'فواتير آليّة، روابط دفع، احتساب الغرامات، وتذكيرات للمستأجرين.' },
        points: [
          { en: 'SAR-native ledger',       ar: 'دفتر حسابات بالريال السعودي' },
          { en: 'Auto-reconciliation',     ar: 'تسوية تلقائيّة للدفعات' },
        ],
        aiEmbedded: false,
        to: '/payments',
      },
      {
        icon: 'Wrench',
        title: { en: 'Maintenance & vendors', ar: 'الصيانة والموردون' },
        desc:  { en: 'Work orders, SLA tracking, vendor directory, and photo-based evidence.', ar: 'أوامر العمل، متابعة اتفاقيّات الخدمة، دليل الموردين، وأدلّة بالصور.' },
        points: [
          { en: 'Photo-based AI triage',    ar: 'فرز ذكي للبلاغات عبر الصور' },
          { en: 'Vendor SLA dashboards',    ar: 'لوحات أداء الموردين' },
        ],
        aiEmbedded: true,
        to: '/maintenance',
      },
      {
        icon: 'FileText',
        title: { en: 'Accounting & ledger',   ar: 'المحاسبة والدفتر العام' },
        desc:  { en: 'Tenant ledger, general ledger, expense tracking, and owner statements.', ar: 'دفتر المستأجرين، الدفتر العام، تتبّع المصروفات، وكشوفات الملّاك.' },
        points: [
          { en: 'Owner statement automation', ar: 'أتمتة كشوفات الملّاك' },
          { en: 'Multi-entity consolidation', ar: 'توحيد متعدّد الكيانات' },
        ],
        aiEmbedded: false,
        to: '/finance',
      },
      {
        icon: 'BarChart3',
        title: { en: 'Reporting',             ar: 'التقارير' },
        desc:  { en: 'Live KPIs, drill-down dashboards, and board-quality PDFs in Arabic and English.', ar: 'مؤشّرات أداء حيّة، لوحات تفاعليّة، وتقارير PDF بجودة مجلس الإدارة بالعربيّة والإنجليزيّة.' },
        points: [
          { en: 'Arabic & English board PDFs', ar: 'تقارير المجلس بالعربيّة والإنجليزيّة' },
          { en: 'Custom KPI dashboards',       ar: 'لوحات مؤشّرات قابلة للتخصيص' },
        ],
        aiEmbedded: true,
        to: '/reports',
      },
      {
        icon: 'Users',
        title: { en: 'Tenant portal',         ar: 'بوّابة المستأجر' },
        desc:  { en: 'Self-service payments, maintenance requests, document signing, and announcements.', ar: 'دفع ذاتي، طلبات صيانة، توقيع الوثائق، وإعلانات المجتمع.' },
        points: [
          { en: 'Arabic and English UX',      ar: 'تجربة عربيّة وإنجليزيّة' },
          { en: 'WhatsApp-ready notifications', ar: 'إشعارات جاهزة عبر واتساب' },
        ],
        aiEmbedded: false,
        to: '/tenant-portal',
      },
    ],
  },
  // ── Honest "Built for KSA" capability band (replaces fake customer claims)
  proof: {
    eyebrow: { en: 'Built for the Saudi market', ar: 'مبنيّة للسوق السعوديّ' },
    statement: {
      en: 'A platform that speaks the way Saudi operators actually work.',
      ar: 'منصّة تنطق بنفس الطريقة التي يعمل بها المشغّلون في المملكة.',
    },
    body: {
      en: 'REVA is built bilingual from the ground up — Arabic and English, right-to-left and left-to-right. Saudi Riyal is the native currency, the calendar respects Hijri dates, and board reports are produced in Arabic with the typographic quality your investors expect.',
      ar: 'صُمّمت REVA منذ اليوم الأوّل بلغتين — العربيّة والإنجليزيّة، ومن اليمين إلى اليسار وبالعكس. الريال السعوديّ هو العملة الأصليّة، والتقويم يحترم التقويم الهجريّ، وتُنتج تقارير مجلس الإدارة بالعربيّة بجودة الطباعة التي يتوقّعها مستثمروك.',
    },
    bigLabel: { en: 'bilingual · SAR-native · Hijri-aware', ar: 'ثنائيّة اللغة · ريال سعوديّ أصليّ · تقويم هجريّ' },
  },
  pulse: {
    eyebrow: { en: 'Portfolio at a glance', ar: 'محفظتك · لمحة' },
    title:   { en: 'Your portfolio. Live, every second.', ar: 'محفظتك. حيّة، كل ثانية.' },
    metrics: [
      { k: { en: 'Active leases',         ar: 'عقود فعّالة' },        v: '1.3K',   d: { en: '+18 this wk',         ar: '+18 هذا الأسبوع' },     tone: 'signal' },
      { k: { en: 'Occupancy',             ar: 'الإشغال' },             v: '92.4%',  d: { en: '+1.8 pp · 30d',        ar: '+1.8 ن٪ · 30 يوم' },     tone: 'mint' },
      { k: { en: 'Collections',           ar: 'التحصيل' },             v: '98.1%',  d: { en: '↑ above forecast',     ar: '↑ فوق التوقّع' },        tone: 'mint' },
      { k: { en: 'NOI · annualized',       ar: 'صافي الدخل · سنوي' }, v: '34.2M',  d: { en: 'SAR · +11.2% YoY',     ar: 'ر.س · +11.2٪ سنوي' },   tone: 'signal' },
      { k: { en: 'Revenue leak',          ar: 'تسرّب إيرادات' },      v: '142K',   d: { en: 'SAR · flagged',         ar: 'ر.س · مرصودة' },         tone: 'amber' },
      { k: { en: 'AI recommendations',    ar: 'توصيات الذكاء' },      v: '37',     d: { en: 'ready for review',     ar: 'بانتظار المراجعة' },     tone: 'signal' },
    ],
  },
  ops: {
    eyebrow: { en: 'Operational intelligence', ar: 'ذكاء العمليّات' },
    titleA:  { en: 'A command center',          ar: 'مركز تحكّم' },
    titleB:  { en: 'that thinks ahead.',        ar: 'يستبق احتياجاتك.' },
    sub: {
      en: 'REVA continuously analyzes every signal across your portfolio — vacancy risk, collection drift, NOI anomalies, maintenance trends — and surfaces the next operational decision before your team has to ask.',
      ar: 'تتابع REVA كل مؤشّر في محفظتك باستمرار — مخاطر الشغور، تأخّر التحصيل، تذبذب صافي الدخل، اتجاهات الصيانة — وتقترح الإجراء التالي قبل أن يسأله فريقك.',
    },
    panel: {
      title:  { en: 'OPERATOR · COMMAND CENTER · LIVE', ar: 'المشغّل · مركز القيادة · حي' },
      noi:    { en: 'NOI · TRAILING 12M',                 ar: 'صافي الدخل · 12 شهر' },
      occ:    { en: 'OCCUPANCY HEAT · PORTFOLIO',          ar: 'حرارة الإشغال · المحفظة' },
      streams:{ en: 'LIVE SIGNAL STREAM',                   ar: 'تدفّق الإشارة الحي' },
      reco:   { en: 'AI RECOMMENDATIONS',                   ar: 'توصيات الذكاء' },
      anomalies: { en: 'ANOMALY DETECTION',                 ar: 'كشف الشذوذ' },
    },
    streamItems: [
      { tag: { en: 'REVENUE',   ar: 'إيرادات' },  text: { en: 'Unit B-12 · rent below market by 7.4%',   ar: 'وحدة B-12 · إيجار أقل من السوق 7.4٪' },   tone: 'amber' },
      { tag: { en: 'VACANCY',   ar: 'شغور' },     text: { en: '4 leases · churn risk · next 30d',        ar: '4 عقود · خطر مغادرة · 30 يوم' },         tone: 'coral' },
      { tag: { en: 'OPS',       ar: 'عمليات' },   text: { en: 'HVAC ticket cluster · Olaya tower',       ar: 'تكتل صيانة تكييف · برج العليا' },       tone: 'signal' },
      { tag: { en: 'COLLECTION',ar: 'تحصيل' },    text: { en: 'WhatsApp pay-link · 24 payments cleared',  ar: 'رابط واتساب · 24 دفعة محصّلة' },        tone: 'mint' },
      { tag: { en: 'LEASE',     ar: 'عقد' },      text: { en: 'PDF ingested · 312 clauses extracted',     ar: 'PDF مستوعب · 312 بند مستخرج' },         tone: 'signal' },
      { tag: { en: 'FORECAST',  ar: 'تنبؤ' },     text: { en: 'Q1 NOI · projected +9.6% vs plan',         ar: 'صافي الدخل ر1 · +9.6٪ عن الخطة' },     tone: 'mint' },
    ],
    recos: [
      { title: { en: 'Reprice 6 units · Olaya cluster', ar: 'إعادة تسعير 6 وحدات · مجمع العليا' }, impact: { en: '+186K SAR / yr', ar: '+186 ألف ر.س/سنوي' }, conf: '94%' },
      { title: { en: 'Retain tenant FAS-2104 · offer +3% concession', ar: 'استبقاء المستأجر FAS-2104 · خصم +3٪' }, impact: { en: 'protects 224K SAR', ar: 'يحمي 224 ألف ر.س' }, conf: '91%' },
      { title: { en: 'Bundle 3 maintenance tickets · vendor 412', ar: 'دمج 3 تذاكر صيانة · مزوّد 412' }, impact: { en: '−38% labor cost', ar: '−38٪ تكلفة عمالة' }, conf: '88%' },
    ],
    anomalies: [
      { label: { en: 'Late payment spike',      ar: 'ارتفاع التأخّر' },   delta: '+24%', risk: 'high' },
      { label: { en: 'Maintenance backlog',     ar: 'تراكم صيانة' },     delta: '+11%', risk: 'med' },
      { label: { en: 'Vendor SLA drift',         ar: 'انحراف اتفاقية' },  delta: '+6%',  risk: 'low' },
    ],
  },

  marquee: [
    { en: 'Live signal · 12 portfolios online', ar: 'إشارة حية · 12 محفظة متصلة' },
    { en: 'AI agents · 38 active',              ar: 'وكلاء الذكاء · 38 نشط' },
    { en: 'Streaming · 2.4M events / hr',       ar: 'تدفّق · 2.4 مليون حدث/ساعة' },
    { en: 'WhatsApp gateway · operational',     ar: 'بوابة واتساب · تعمل' },
    { en: 'SOC2 boundary · enforced',           ar: 'حدود SOC2 · مفعّلة' },
    { en: 'Predictions · 90 days · 94% acc',    ar: 'توقعات · 90 يوم · دقة 94٪' },
    { en: 'Vendor mesh · 412 verified',         ar: 'شبكة المزوّدين · 412 موثوق' },
    { en: 'Auto workflows · 6,430 / mo',        ar: 'أتمتة العمليات · 6,430 شهرياً' },
  ],
  problem: {
    eyebrow:  { en: 'The shift',          ar: 'التحوّل' },
    titleA:   { en: 'Spreadsheets log the past.', ar: 'الجداول تسجّل الماضي.' },
    titleB:   { en: 'REVA decides the future.',   ar: 'REVA تقرر المستقبل.' },
    oldHeader: { en: 'The old stack',     ar: 'النظام القديم' },
    newHeader: { en: 'The REVA operating plane', ar: 'طبقة REVA التشغيلية' },
    old: [
      { en: 'Excel files emailed weekly · stale by lunch',                    ar: 'ملفات إكسل بالبريد أسبوعياً · قديمة قبل الغداء' },
      { en: 'Three PMSs, four spreadsheets, no source of truth',              ar: 'ثلاثة أنظمة، أربعة جداول، ولا مصدر موثوق' },
      { en: 'Decisions wait for the analyst to be free',                      ar: 'القرارات تنتظر تفرّغ المحلّل' },
      { en: 'Lease PDFs read by humans, line by line',                        ar: 'عقود PDF تُقرأ يدوياً، سطراً بسطر' },
      { en: 'Executive reports rebuilt every quarter from scratch',           ar: 'التقارير التنفيذية تُعاد من الصفر كل ربع' },
    ],
    new: [
      { en: 'One live operating plane · sub-second latency',                  ar: 'طبقة تشغيل حيّة واحدة · أقل من الثانية' },
      { en: 'Single intelligence layer · all assets · all roles',             ar: 'طبقة ذكاء واحدة · كل الأصول · كل الأدوار' },
      { en: 'Predictive recommendations triggered automatically',             ar: 'توصيات تنبؤية تتفعّل تلقائياً' },
      { en: 'AI extracts every clause to JSON in 8 seconds',                  ar: 'الذكاء يستخرج كل بند إلى JSON خلال 8 ثوانٍ' },
      { en: 'Executive PDFs drafted by REVA · ready every Monday',            ar: 'تقارير PDF تنفيذية تكتبها REVA · جاهزة كل اثنين' },
    ],
  },
  layers: {
    eyebrow: { en: 'The architecture',          ar: 'البنية' },
    titleA:  { en: 'Three planes.',             ar: 'ثلاث طبقات.' },
    titleB:  { en: 'One operating system.',     ar: 'نظام تشغيل واحد.' },
    sub: {
      en: 'Every action in REVA flows top-down: data is ingested, intelligence is computed, the operator decides. No silos, no pipeline drift, no spreadsheets exported between teams.',
      ar: 'كل عملية في REVA تتدفّق من الأعلى للأسفل: البيانات تُستوعب، الذكاء يُحتسب، المشغّل يقرّر. بلا حواجز، بلا تشتّت، بلا جداول تُتبادل بين الفرق.',
    },
    items: [
      { n: '01', icon: Database, tag: { en: 'INGEST · NORMALIZE', ar: 'استيعاب · توحيد' }, title: { en: 'Data plane',         ar: 'طبقة البيانات' },         desc: { en: 'Ingest any messy file. AI maps Arabic + English columns, normalizes 7 sheets, and resolves entity graphs in seconds.', ar: 'استوعب أي ملف. يطابق الذكاء الأعمدة العربية والإنجليزية، يوحّد 7 ورقات، ويحل الروابط خلال ثوانٍ.' } },
      { n: '02', icon: Brain,    tag: { en: 'PREDICT · DECIDE',   ar: 'تنبؤ · قرار' },     title: { en: 'Intelligence plane', ar: 'طبقة الذكاء' },           desc: { en: 'GPT-class models forecast vacancy, score tenants, abstract leases, and surface revenue leaks before they happen.', ar: 'نماذج بمستوى GPT تتوقّع الشغور، تقيّم المستأجرين، تستخلص العقود، وترصد تسرّب الإيرادات قبل وقوعه.' } },
      { n: '03', icon: Workflow, tag: { en: 'AUTOMATE · EXECUTE', ar: 'أتمتة · تنفيذ' },    title: { en: 'Operator plane',     ar: 'طبقة المشغّل' },          desc: { en: 'Operators act in seconds — task-based modules, executive PDFs, WhatsApp dispatch, automated vendor handoff.', ar: 'المشغّلون يتصرفون خلال ثوانٍ — وحدات مبنية على المهام، تقارير PDF تنفيذية، إرسال واتساب، تحويل تلقائي للمزوّدين.' } },
    ],
  },
  workbench: {
    eyebrow: { en: 'AI workbench',              ar: 'منصة الذكاء' },
    titleA:  { en: 'Drop any file.',            ar: 'أسقط أي ملف.' },
    titleB:  { en: 'REVA reads it.',            ar: 'REVA تفهمه.' },
    sub: {
      en: "Customer files arrive in dozens of shapes — Arabic columns, oddly-named sheets, mixed languages. REVA's column-mapper detects intent with exact, fuzzy, and semantic engines. Onboarding a portfolio takes minutes, not weeks.",
      ar: 'تأتي ملفات العملاء بعشرات الأشكال — أعمدة عربية، أوراق بأسماء غريبة، لغات مختلطة. مطابق الأعمدة في REVA يكتشف القصد بمحركات دقيقة وتقريبية ودلاليّة. تأهيل المحفظة بدقائق لا أسابيع.',
    },
    chips: [
      { en: '7 sheets',          ar: '7 ورقات' },
      { en: 'AR + EN',           ar: 'عربي + إنجليزي' },
      { en: 'Exact · Fuzzy · AI', ar: 'دقيق · تقريبي · ذكي' },
      { en: '< 90s p95',         ar: '< 90 ث · p95' },
    ],
    cols: { raw: { en: 'raw column', ar: 'العمود الأصلي' }, sug: { en: 'AI suggestion', ar: 'اقتراح الذكاء' }, conf: { en: 'confidence', ar: 'الثقة' } },
    footer:  { en: '42 columns · 7 sheets · resolved in 6.2s', ar: '42 عمود · 7 ورقات · حُلّت خلال 6.2 ث' },
    cta:     { en: 'Confirm import', ar: 'تأكيد الاستيراد' },
  },
  decision: {
    eyebrow: { en: 'Decision engine',    ar: 'محرك القرار' },
    titleA:  { en: 'Built around',       ar: 'مبنيّ حول' },
    titleB:  { en: 'outcomes',           ar: 'النتائج' },
    titleC:  { en: ', not entities.',    ar: '، لا الكيانات.' },
    sub:     { en: "Operators don't think in CRUD. REVA's modules are organized by the goal you're trying to hit — every screen pre-computes the next decision.", ar: 'المشغّلون لا يفكّرون في CRUD. وحدات REVA منظَّمة حول الهدف الذي تسعى إليه — كل شاشة تحسب القرار التالي مسبقاً.' },
    tiles: [
      { icon: Wallet,    title: { en: 'Increase revenue',    ar: 'زيادة الإيرادات' }, desc: { en: 'Find under-leased units, score market gap, push optimal rent by unit.',           ar: 'اكتشف الوحدات منخفضة الإيجار، قِس فجوة السوق، اضبط الإيجار الأمثل لكل وحدة.' }, route: '/insights',     color: 'mint' },
      { icon: Building2, title: { en: 'Reduce vacancy',      ar: 'تقليل الشواغر' },   desc: { en: 'Predictive tenant churn, vacancy heatmap, dispatch retention plays.',              ar: 'تنبّأ بمغادرة المستأجرين، خريطة الشغور، خطط استبقاء آلية.' },              route: '/units',        color: 'signal' },
      { icon: Gauge,     title: { en: 'Portfolio health',    ar: 'صحة المحفظة' },     desc: { en: 'NOI, DSCR, occupancy trend with peer benchmarks — live.',                          ar: 'صافي الدخل التشغيلي، نسبة تغطية الدين، الإشغال — حياً مع المقارنة.' },     route: '/dashboard',    color: 'amber' },
      { icon: Wrench,    title: { en: 'Operations',          ar: 'العمليات' },         desc: { en: 'Auto-route maintenance, vendor SLA tracking, cost forecasts.',                    ar: 'توجيه الصيانة آلياً، تتبّع اتفاقيات الخدمة، توقعات التكلفة.' },           route: '/maintenance',  color: 'signal' },
      { icon: FileText,  title: { en: 'Compliance',          ar: 'الامتثال' },         desc: { en: 'Lease expiry, regulatory filings, document gaps surfaced before audit.',         ar: 'انتهاء العقود، الإقرارات النظامية، فجوات المستندات قبل التدقيق.' },       route: '/lease-abstract', color: 'mint' },
      { icon: Users,     title: { en: 'Tenant operations',   ar: 'عمليات المستأجرين' }, desc: { en: 'WhatsApp pay-link, rent reminders, satisfaction scoring.',                       ar: 'روابط دفع واتساب، تذكير الإيجار، تقييم رضا المستأجر.' },                 route: '/tenants',      color: 'amber' },
    ],
    cta: { en: 'Open module', ar: 'افتح الوحدة' },
  },
  lease: {
    eyebrow: { en: 'Lease abstraction', ar: 'استخلاص العقود' },
    titleA:  { en: 'Every clause.',     ar: 'كل بند.' },
    titleB:  { en: 'Structured.',       ar: 'منظّم.' },
    sub:     { en: 'Drop a 40-page lease PDF. REVA returns clean JSON in 8 seconds — tenant, rent, term, indemnities, renewal logic — ready for the engine to act on.', ar: 'أسقط عقد PDF من 40 صفحة. REVA تُعيد JSON نظيف خلال 8 ثوانٍ — المستأجر، الإيجار، المدة، التعويضات، منطق التجديد — جاهز للتنفيذ.' },
    extracting: { en: 'EXTRACTING…',     ar: 'جارٍ الاستخراج…' },
    footer:     { en: '40 pages · 312 clauses · 0 manual review needed', ar: '40 صفحة · 312 بند · بلا مراجعة يدوية' },
    cta:        { en: 'Try lease abstraction', ar: 'جرّب الاستخلاص' },
  },
  predict: {
    eyebrow: { en: 'Predictive intelligence',     ar: 'الذكاء التنبّؤي' },
    titleA:  { en: 'Forecast vacancy',            ar: 'توقّع الشغور' },
    titleB:  { en: '90 days out.',                ar: 'قبل 90 يوم.' },
    chartTitle: { en: 'OCCUPANCY · PORTFOLIO HEATMAP · 90D', ar: 'الإشغال · خريطة المحفظة · 90 يوم' },
    chartConf:  { en: '94.2% confidence',         ar: 'ثقة 94.2٪' },
    cards: [
      { label: { en: 'Risk units · 30d',          ar: 'وحدات معرّضة · 30 يوم' }, value: '12', delta: { en: '−4 vs last wk', ar: '−4 مقارنة بالأسبوع الماضي' } },
      { label: { en: 'Predicted move-outs',       ar: 'مغادرات متوقّعة' },       value: '7',  delta: { en: 'Riyadh · 4 / Jeddah · 3', ar: 'الرياض · 4 / جدة · 3' } },
      { label: { en: 'Renewal candidates',        ar: 'مرشّحون للتجديد' },       value: '36', delta: { en: 'auto-drafted offers', ar: 'عروض جاهزة آلياً' } },
    ],
  },
  exec: {
    eyebrow: { en: 'Executive command center', ar: 'مركز القيادة التنفيذي' },
    titleA:  { en: 'Monday morning,',          ar: 'صباح الاثنين،' },
    titleB:  { en: 'board-ready.',             ar: 'جاهز للمجلس.' },
    sub:     { en: 'REVA writes the executive narrative for you — KPIs, risks, recommendations, and signed-off PDFs. Owners and asset managers spend less time assembling decks, more time deciding.', ar: 'REVA تكتب الرواية التنفيذية لك — مؤشرات، مخاطر، توصيات، وتقارير PDF موقّعة. المالكون والمديرون يقضون وقتاً أقل في التجميع وأكثر في القرار.' },
    chips: [
      { en: 'EN + AR',     ar: 'عربي + إنجليزي' },
      { en: 'PDF · DOCX',  ar: 'PDF · DOCX' },
      { en: 'Owner brand', ar: 'هوية المالك' },
      { en: 'IFRS-aligned', ar: 'متوافق IFRS' },
    ],
    reportTitle: { en: 'EXECUTIVE_REPORT_Q1_2026.pdf', ar: 'تقرير_تنفيذي_الربع_الأول_2026.pdf' },
    drafted: { en: 'drafted by REVA · 14:02', ar: 'كتبته REVA · 14:02' },
    bullets: [
      { en: 'Riyadh portfolio outperformed plan by 6.8% — driven by Olaya cluster',                ar: 'محفظة الرياض تجاوزت الخطة بنسبة 6.8٪ — بقيادة مجمع العليا' },
      { en: 'Three vacancy risks flagged · auto-retention plays drafted for owner approval',       ar: 'ثلاث مخاطر شغور · خطط استبقاء آلية بانتظار موافقة المالك' },
      { en: 'Refinancing window opens in 42 days — DSCR sits comfortably above covenant',           ar: 'نافذة إعادة التمويل تفتح بعد 42 يوم — DSCR أعلى من الشرط بأمان' },
    ],
    cta: { en: 'See sample report', ar: 'شاهد عيّنة تقرير' },
  },
  tenant: {
    eyebrow: { en: 'Tenant operations', ar: 'عمليات المستأجرين' },
    titleA:  { en: 'Conversational,',   ar: 'تفاعلي،' },
    titleB:  { en: 'always on.',        ar: 'دائماً متاح.' },
    items: [
      { icon: Radio, title: { en: 'WhatsApp gateway', ar: 'بوابة واتساب' },   desc: { en: 'Pay-link issued in one tap. Receipt back in seconds.',           ar: 'رابط دفع بنقرة واحدة. الإيصال يعود خلال ثوانٍ.' } },
      { icon: Bot,   title: { en: 'Triage agent',     ar: 'وكيل الفرز' },     desc: { en: 'Maintenance requests auto-classified and dispatched.',          ar: 'طلبات الصيانة تُصنّف وتُرسَل آلياً.' } },
      { icon: Boxes, title: { en: 'Resident portal',  ar: 'بوابة الساكن' },   desc: { en: 'Lease, dues, requests — all in a single Arabic-aware view.',    ar: 'العقد، المستحقات، الطلبات — في واجهة عربية واحدة.' } },
    ],
  },
  vendor: {
    eyebrow: { en: 'Vendor mesh',          ar: 'شبكة المزوّدين' },
    titleA:  { en: 'A living network',     ar: 'شبكة حيّة' },
    titleB:  { en: 'of operators.',        ar: 'من المشغّلين.' },
    sub:     { en: 'Every approved vendor, every SLA, every invoice — mapped, scored, and routable from one console. REVA picks the best vendor for each ticket.', ar: 'كل مزوّد، كل اتفاقية، كل فاتورة — مرسومة، مصنّفة، وقابلة للتوجيه من لوحة واحدة. REVA تختار الأنسب لكل تذكرة.' },
    categories: [
      { en: 'HVAC',       ar: 'تكييف' },
      { en: 'Plumbing',   ar: 'سباكة' },
      { en: 'Electrical', ar: 'كهرباء' },
      { en: 'Cleaning',   ar: 'نظافة' },
      { en: 'Security',   ar: 'حراسة' },
      { en: 'Landscape',  ar: 'تنسيق' },
    ],
  },
  security: {
    eyebrow: { en: 'Security & compliance', ar: 'الأمان والامتثال' },
    title: { en: "Built for portfolios that can't afford to leak.", ar: 'أمان مصمَّم لمحافظ لا تحتمل أي تسرّب.' },
    items: [
      { icon: Lock,        title: { en: 'Tenant isolation', ar: 'عزل بيانات كل عميل' },  desc: { en: 'Per-organization data plane. Never crossed.', ar: 'طبقة بيانات مستقلّة لكل منظّمة. لا تتقاطع أبدًا.' } },
      { icon: ShieldCheck, title: { en: 'SOC2 ready',       ar: 'جاهز لـ SOC 2' },         desc: { en: 'Audit-trailed actions, immutable history.',   ar: 'سجلّ تدقيق لكل إجراء، وتاريخ غير قابل للتعديل.' } },
      { icon: Globe,       title: { en: 'KSA-resident',     ar: 'بيانات داخل المملكة' }, desc: { en: 'PDPL-aligned data residency on request.',  ar: 'إقامة بيانات تتوافق مع نظام حماية البيانات الشخصيّة عند الطلب.' } },
      { icon: Cpu,         title: { en: 'Model boundary',   ar: 'حدود نموذج الذكاء' },    desc: { en: 'No customer data leaves the boundary for training.', ar: 'بيانات العميل لا تغادر الحدود لأي تدريب على النماذج.' } },
    ],
  },
  arch: {
    eyebrow: { en: 'Architecture',        ar: 'البنية التقنية' },
    title:   { en: 'One stack, every operator.', ar: 'بنية واحدة، لكل مشغّل.' },
    rows: [
      { title: { en: 'Operator surfaces',  ar: 'واجهات المشغّل' },  tags: { en: 'Web · Mobile · WhatsApp · PDF · API', ar: 'ويب · جوال · واتساب · PDF · API' } },
      { title: { en: 'Decision engine',    ar: 'محرك القرار' },     tags: { en: 'Vacancy ML · Rent optimizer · Risk scoring · Workflows', ar: 'تعلم آلي للشغور · مُحسّن إيجار · تقييم مخاطر · أتمتة' } },
      { title: { en: 'Intelligence plane', ar: 'طبقة الذكاء' },     tags: { en: 'Lease abstractor · Column mapper · Forecast models', ar: 'مستخلص عقود · مطابق أعمدة · نماذج تنبؤ' } },
      { title: { en: 'Data plane',         ar: 'طبقة البيانات' },   tags: { en: 'Streaming ingest · Entity graph · Audit log · Vector store', ar: 'استيعاب متدفّق · رسم كيانات · سجل تدقيق · مخزن متجهات' } },
      { title: { en: 'Infrastructure',     ar: 'البنية التحتية' },   tags: { en: 'Tenant isolation · KSA region · SOC2 boundary',     ar: 'عزل العملاء · منطقة السعودية · حدود SOC2' } },
    ],
  },
  trusted: { title: { en: 'OPERATORS · ASSET MANAGERS · OWNERS · USING REVA', ar: 'مشغّلون · مديرو أصول · مالكون · يستخدمون REVA' } },
  quotes: [
    { q: { en: 'Cut quarterly close from 11 days to a Monday morning. Our analyst is finally an analyst again.', ar: 'اختصرنا الإقفال الربعي من 11 يوماً إلى صباح اثنين. محلّلنا عاد محلّلاً.' }, a: { en: 'CFO · 412-unit operator', ar: 'مدير مالي · مشغّل 412 وحدة' } },
    { q: { en: 'The AI lease abstractor saved us from a 7-figure renewal we almost missed.',                       ar: 'مستخلص العقود أنقذنا من تجديد بسبعة أرقام كاد يفوتنا.' }, a: { en: 'Asset manager · Riyadh',  ar: 'مدير أصول · الرياض' } },
    { q: { en: "It's the only software my GM and my chairman both open every morning.",                            ar: 'الوحيد الذي يفتحه المدير العام ورئيس المجلس كل صباح.' }, a: { en: 'Owner · Western region',   ar: 'مالك · المنطقة الغربية' } },
  ],
  compare: {
    eyebrow: { en: 'REVA vs legacy', ar: 'REVA مقابل التقليدي' },
    title:   { en: 'A different operating model.', ar: 'نموذج تشغيل مختلف.' },
    headers: { cap: { en: 'Capability', ar: 'القدرة' }, legacy: { en: 'Legacy PMS', ar: 'النظام التقليدي' }, reva: { en: 'REVA', ar: 'REVA' } },
    rows: [
      { a: { en: 'Onboarding time',         ar: 'زمن التأهيل' },         b: { en: 'Weeks of consulting',          ar: 'أسابيع من الاستشارات' },          c: { en: '< 90 seconds (AI mapper)',   ar: '< 90 ث (مطابق الذكاء)' } },
      { a: { en: 'Lease abstraction',       ar: 'استخلاص العقود' },      b: { en: 'Manual paralegal review',      ar: 'مراجعة قانونية يدوية' },           c: { en: 'Auto · 8 sec / lease',       ar: 'آلي · 8 ث / عقد' } },
      { a: { en: 'Executive reports',       ar: 'التقارير التنفيذية' },  b: { en: 'Quarterly · rebuilt by hand',  ar: 'ربعية · تُعاد يدوياً' },           c: { en: 'Drafted weekly by REVA',     ar: 'تكتبها REVA أسبوعياً' } },
      { a: { en: 'Vacancy forecast',        ar: 'توقّع الشغور' },        b: { en: "Last quarter's number",        ar: 'رقم الربع الماضي' },               c: { en: '90-day · 94% accuracy',      ar: '90 يوم · دقة 94٪' } },
      { a: { en: 'Tenant comms',            ar: 'تواصل المستأجرين' },    b: { en: 'Email + WhatsApp + spreadsheets', ar: 'بريد + واتساب + جداول' },        c: { en: 'Single live thread',         ar: 'محادثة واحدة حيّة' } },
      { a: { en: 'Vendor selection',        ar: 'اختيار المزوّدين' },    b: { en: 'Tribal knowledge',              ar: 'معرفة شخصية' },                    c: { en: 'Scored · routed · live SLAs', ar: 'مصنّف · موجّه · اتفاقيات حيّة' } },
    ],
  },
  cta: {
    eyebrow: { en: 'See REVA in action', ar: 'شاهد REVA على أرض الواقع' },
    title: { en: 'See your portfolio inside REVA in 30 minutes.', ar: 'شاهد محفظتك داخل REVA في 30 دقيقة.' },
    sub: { en: "We'll plug in a sample of your data live during the call, walk you through the platform, and show you the reporting — yours to keep regardless.", ar: 'نُدخل عيّنة من بياناتك مباشرة خلال المكالمة، ونأخذك في جولة على المنصّة، ونريك التقارير — يبقى الجميع معك في كل الأحوال.' },
    btn: { en: 'Request a demo', ar: 'اطلب عرضًا توضيحيًا' },
  },
  faq: {
    eyebrow: { en: 'FAQ', ar: 'الأسئلة الشائعة' },
    title: { en: 'Operator questions, answered.', ar: 'أسئلة المشغّلين، مُجابة.' },
    items: [
      { q: { en: 'How long does onboarding actually take?', ar: 'كم يستغرق التأهيل فعلياً؟' },
        a: { en: 'Most operators are running on REVA the same day. The AI column-mapper ingests existing spreadsheets without you reformatting anything.', ar: 'أغلب المشغّلين يعملون على REVA في نفس اليوم. مطابق الأعمدة يستوعب جداولك الحالية دون إعادة تنسيق.' } },
      { q: { en: 'Where does my data live?', ar: 'أين تُحفظ بياناتي؟' },
        a: { en: 'Per-tenant isolation by default. KSA region available on request. Customer data never trains foundation models.', ar: 'عزل بيانات لكل عميل افتراضياً. منطقة السعودية متاحة عند الطلب. لا تُستخدم بيانات العملاء في تدريب النماذج.' } },
      { q: { en: 'Do you support Arabic?', ar: 'هل تدعمون العربية؟' },
        a: { en: 'Native AR + EN throughout the product. The AI column-mapper handles mixed-language source files automatically.', ar: 'دعم أصلي للعربية والإنجليزية في كل المنتج. ومطابق الأعمدة يتعامل مع الملفات مختلطة اللغة آلياً.' } },
      { q: { en: 'How are predictions computed?', ar: 'كيف تُحتسب التوقعات؟' },
        a: { en: 'Bespoke models trained on portfolio behaviour, not foundation-model fine-tunes. Confidence intervals are surfaced on every forecast.', ar: 'نماذج مخصّصة مدرَّبة على سلوك المحفظة، لا تعديلات فوقية لنماذج عامة. ونعرض نطاق الثقة مع كل توقّع.' } },
      { q: { en: 'Can I export everything?', ar: 'هل يمكنني تصدير كل البيانات؟' },
        a: { en: 'Yes. Excel, PDF, CSV and a full read API. Your data is yours.', ar: 'نعم. إكسل، PDF، CSV، وواجهة قراءة كاملة. بياناتك ملك لك.' } },
    ],
  },
  footer: {
    tag: { en: 'REVA — property operations platform for the Saudi market.', ar: 'REVA — منصّة إدارة العقارات في السوق السعوديّ.' },
    cols: [
      { h: { en: 'Platform', ar: 'المنصة' }, l: [
        { t: { en: 'Decision engine',  ar: 'محرك القرار' },   to: '#intelligence' },
        { t: { en: 'AI workbench',     ar: 'منصة الذكاء' },   to: '#platform' },
        { t: { en: 'Architecture',    ar: 'البنية' },        to: '#architecture' },
      ] },
      { h: { en: 'Modules', ar: 'الوحدات' }, l: [
        { t: { en: 'Revenue',    ar: 'الإيرادات' },   to: '#modules' },
        { t: { en: 'Vacancy',    ar: 'الشواغر' },    to: '#modules' },
        { t: { en: 'Operations', ar: 'العمليات' },   to: '#modules' },
        { t: { en: 'Compliance', ar: 'الامتثال' },   to: '#modules' },
      ] },
      { h: { en: 'Company', ar: 'الشركة' }, l: [
        { t: { en: 'About',    ar: 'عن REVA' },    to: 'mailto:hello@reva.sa?subject=About REVA' },
        { t: { en: 'Security', ar: 'الأمان' },     to: '#security' },
        { t: { en: 'Contact',  ar: 'تواصل' },      to: 'mailto:hello@reva.sa' },
      ] },
    ],
    rights: { en: '© REVA Labs · Operator OS', ar: '© REVA Labs · نظام تشغيل المشغّل' },
    nominal: { en: 'All systems nominal', ar: 'كل الأنظمة تعمل' },
  },
  demo: {
    eyebrow: { en: 'Operator briefing', ar: 'جلسة المشغّل' },
    title:   { en: 'Tell us about your portfolio.', ar: 'حدّثنا عن محفظتك.' },
    success: { en: 'Briefing requested.', ar: 'تم طلب الجلسة.' },
    successSub: { en: 'An operator will reach out within one business day.', ar: 'سيتواصل معك أحد المشغّلين خلال يوم عمل واحد.' },
    close: { en: 'Close', ar: 'إغلاق' },
    ph: {
      name:    { en: 'Full name',         ar: 'الاسم الكامل' },
      email:   { en: 'Work email',        ar: 'البريد المهني' },
      company: { en: 'Company',           ar: 'الشركة' },
      phone:   { en: 'Phone (optional)',  ar: 'الجوال (اختياري)' },
      message: { en: 'What are you trying to fix? (optional)', ar: 'ما الذي تحاول إصلاحه؟ (اختياري)' },
      units:   { en: 'units',             ar: 'وحدة' },
    },
    submit: { en: 'Request briefing', ar: 'اطلب الجلسة' },
  },
  tour: {
    title: { en: 'Where to start', ar: 'من أين تبدأ' },
    sub:   { en: 'Jump straight into the part of REVA you want to see.', ar: 'ادخل مباشرة إلى الجزء الذي تريد رؤيته من REVA.' },
    primary: { en: 'Sign in to live demo', ar: 'دخول الديمو الحي' },
    items: [
      { t: { en: 'Operator OS dashboard',    ar: 'لوحة المشغّل' },         d: { en: 'Real KPIs, AI recommendations, live filters.', ar: 'مؤشرات حية، توصيات الذكاء، فلاتر.' },        to: '/dashboard' },
      { t: { en: 'AI workbench (import)',    ar: 'منصة الذكاء (الاستيراد)' }, d: { en: 'Drop your messy spreadsheet. We do the rest.',  ar: 'أسقط جدولك. نتولى الباقي.' },         to: '/excel-import' },
      { t: { en: 'Lease abstraction',        ar: 'استخلاص العقود' },     d: { en: 'PDF → structured JSON in seconds.',          ar: 'PDF → JSON منظّم بثوانٍ.' },                 to: '/lease-abstract' },
      { t: { en: 'AI insights',              ar: 'رؤى الذكاء' },          d: { en: 'Vacancy forecasts, revenue recommendations.', ar: 'توقع الشغور، توصيات الإيرادات.' },          to: '/ai-insights' },
    ],
  },
};

export default T;
